import React from "react";
import "../../node_modules/react-vis/dist/style.css";
import {
  XYPlot,
  XAxis,
  YAxis,
  makeVisFlexible,
  VerticalGridLines,
  HorizontalGridLines,
  VerticalBarSeries,
  DiscreteColorLegend,
} from "react-vis";

const MultiBar = (props) => {
  const BarSeries = VerticalBarSeries;
  const FlexibleXYPlot = makeVisFlexible(XYPlot);
  const { data, ticks, lookup } = props;

  const myPalette = {
    1: '#164B48',
    2: '#246F5D',
    3: '#459369',
    4: '#76B76E',
    5: '#B2D96F',
    6: '#F9F871',
    7: '#FFE583'
  }

  const legends = [
    {title: "Maandag", color: myPalette[1]},
    {title: "Dinsdag", color: myPalette[2]},
    {title: "Woensdag", color: myPalette[3]},
    {title: "Donderdag", color: myPalette[4]},
    {title: "Vrijdag", color: myPalette[5]},
    {title: "Zaterdag", color: myPalette[6]},
    {title: "Zondag", color: myPalette[7]},
  ];

  return (
    <FlexibleXYPlot xType="ordinal" margin={{ left: 60 }} xDistance={100}>
      <DiscreteColorLegend height={400} width={400} items={legends} />
      <VerticalGridLines />
      <HorizontalGridLines />
      <XAxis tickFormat={(v) => `${lookup[v]}`} tickValues={ticks} />
      <YAxis tickFormat={(v) => `${v} %`} />
      {data.map((data, i) => {
        console.log(data);
        return <BarSeries data={data} color={myPalette[i]}/>;
      })}
    </FlexibleXYPlot>
  );
};

export default MultiBar;
